import { useMediaQuery } from "react-responsive";

export const useDesktopMediaQuery = (minWidth?: number): boolean =>
  useMediaQuery({ query: `(min-width: ${minWidth ?? 769}px)` });
